export const stripUrlHashAndQuery = (url: string) => url.split(/[?#]/)[0];
export const stripUrlHash = (url: string) => {
  const query = url.match(/(\?[^#]+)/)?.[0] || '';
  const baseUrl = stripUrlHashAndQuery(url);
  return `${baseUrl}${query}`;
};
